import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { paperGoodsIssueBusiness } from "api/bussiness/paper-material/paper-goods-issue";
import { PaperMaterialInventoriesPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IPaperGoodsIssueProperties } from "mobx-stores/_models/paper-inventory/paper-goods-issue/paper-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const PaperGoodsIssueTable = observer(() => {
  const {
    deleteConfirmationStore,
    paperInventoryManagement: {
      paperGoodsIssueStore: {
        paperGoodsIssues,
        getPaperGoodsIssue,
        pagination,
        setProp,
        searchConditionAsNaturalLanguage,
      },
    },
  } = useStores();

  useEffect(() => {
    getPaperGoodsIssue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getPaperGoodsIssue();
    },
    [getPaperGoodsIssue, pagination],
  );

  const onEditBtnClickHandler = useCallback(
    (item: IPaperGoodsIssueProperties) => {
      setProp("openEdit", true);
      setProp("paperGoodsIssueDetail", cloneDeep(item));
    },
    [setProp],
  );

  const onDelete = useCallback(
    async (item: IPaperGoodsIssueProperties) => {
      if (item && item.id) {
        await paperGoodsIssueBusiness.delete(item?.id);
        getPaperGoodsIssue();
      }
    },
    [getPaperGoodsIssue],
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IPaperGoodsIssueProperties) => {
      setProp("paperGoodsIssueDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp],
  );
  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell>Mã số</TableCell>
          <TableCell>Số cuồn</TableCell>
          <TableCell>Loại giấy</TableCell>
          <TableCell>Hiệu</TableCell>
          <TableCell>GSM</TableCell>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>Ngày xuất</TableCell>
          <TableCell>Số LSX</TableCell>
          <TableCell>Trọng lượng (kg)</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paperGoodsIssues.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.items[0]?.material?.code || ""}</TableCell>
            <TableCell>{x.items[0]?.rollNumber || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.type || ""}</TableCell>
            <TableCell>{x.items[0]?.brand || ""}</TableCell>
            <TableCell>{x.items[0]?.material?.gsm || ""}</TableCell>
            <TableCell>
              {x.items[0]?.material?.specificationSize || ""}
            </TableCell>
            <TableCell>{x.items[0]?.length || ""}</TableCell>
            <TableCell>{dateTimeDisplay(x.issueDate) || ""}</TableCell>
            <TableCell>
              {x.items[0]?.workOrderPO?.woNumber ||
                x.items[0]?.workOrder?.woNumber ||
                ""}
            </TableCell>
            <TableCell>
              <NumberText value={x.items[0]?.amount}></NumberText>
            </TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[
                    PaperMaterialInventoriesPermission.IssueUpdate,
                  ]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[
                    PaperMaterialInventoriesPermission.IssueDelete,
                  ]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
